<template>
  <v-layout fill-height column>
    <v-container fluid>
      <div class="question" v-html="ques[0]"></div>
    </v-container>
    <v-container flex-fill>
      <label v-for="n in replyArr.length" :key="n" class="order-list mb-4">
        <input v-if="cmplt" type="checkbox" v-model="answer" :value="replyObjArr[n-1]" @change="click" disabled>
        <input v-else type="checkbox" v-model="answer" :value="replyObjArr[n-1]" @change="click">
        <div>
          <span>{{replyArr[n-1]}}</span>
          <span class="order">{{order(replyArr[n-1])}}</span>
        </div>
      </label>
    </v-container>
    <FooterBtnsNext  @before="$emit('before')" @next="setMemberReply" :current="current" :total="total" :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import FooterBtnsNext from "@/components/btns/FooterBtnsNext";
import store from '../../../store'
export default {
  props:["current","total","unitUseNo","unitDtlUseList","freeYn","cmpltYn","unitDtlUseNo","unitDtlPageSeq"],
  data: () => ({
    disabledNext:true,
    free: 'N',
    cmplt:false,
    answer:[],
    ques:[],
    replyArr:[],
    replyObjArr:[],
    userReplyNo:[0],
    userReply:[],
    selectCnt:0,
  }),
  components: {
    FooterBtnsNext,
  },
  watch: {
    answer(){
      if(this.answer == undefined || this.answer.length <= 0 || this.answer.length < this.selectCnt){
        this.disabledNext = true
      } else{
        this.disabledNext = false
      }
    },
    current(){
      // alert(this.current)
      // 동일 타입 재 조회시 초기화
      this.answer=[],
      this.disabledNext=true,
      this.free= 'N',
      this.cmplt=false,
      this.ques=[],
      this.replyArr=[],
      this.replyObjArr=[],
      this.userReplyNo=[0],
      this.userReply=[],
      this.selectCnt=0,
      this.getUnitDetailUse()
    }
  },
  created () {
    this.getUnitDetailUse()
  },
  methods:{
    async getUnitDetailUse () {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn
      // this.cmplt = true

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo':this.unitDtlUseNo[this.current-1]},
            {'unitDtlPageSeq':this.unitDtlPageSeq[this.current-1]},
            {'freeYn':this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
          .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl,i) => {

              // 질문 셋팅
              // this.ques[i] = quesEl.ques
              this.ques.push(quesEl.ques)
              this.selectCnt = quesEl.selectCnt

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                this.replyArr.push(replyEl.reply)
                this.replyObjArr.push(replyEl)
              });

              // 유저 답변 셋팅
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl,j) => {
                this.userReplyNo[i+j] = userReplyEl.memberUnitDtlReplyUseNo
                this.replyObjArr.forEach((replyObj,k) => {
                  if(replyObj.reply == userReplyEl.reply ){
                    this.answer.push(this.replyObjArr[k])
                  }
                })
              });
            });

          } else {
              console.log(res.msg)
              // this.answer = [];
          }
          })
          .catch(error => {
              console.error(error)
              // this.answer = [];
          })
          .finally(() => {})
    },
    async setMemberReply () {

      if(!this.cmplt){ // 완료상태가 아닐때만 저장
        // 우선순위 답변
        this.answer.forEach((replyObj,i) => {
          this.userReply[i] = {
                                unitId: replyObj.unitId,
                                sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

                                memberUnitDtlReplyUseNo: 0,
                                // unitUseNo: replyObj.unitUseNo,
                                unitNo: replyObj.unitNo,
                                // unitDtlUseNo: replyObj.unitDtlUseNo,
                                unitDtlNo: replyObj.unitDtlNo,
                                // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
                                unitDtlQuesNo: replyObj.unitDtlQuesNo,
                                // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
                                unitDtlReplyNo: replyObj.unitDtlReplyNo,
                                userKey: this.$store.state.auth.authUser.userKey,
                                reply: replyObj.reply,
                                score: i+1,
                                freeYn: this.free,
                                unitType:"09",
                                dtlType:"11"
                              }
        })

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList',this.userReply))
              .then(res => {
                if (res.success) {
                    setTimeout(() => this.$emit('next'), 500); // 저장한 이후
                } else {
                    console.log(res.msg)
                }
              })
              .catch(error => {
                console.error(error)
              })
              .finally(() => {
              })
      } else {
        this.$emit('next')
      }
    },
    order(str){
      let num = ''
      this.answer.forEach((answerEl,i) => {
        if(answerEl.reply == str){
          num = i+1
        }
      })
      return num
    },
    click(event){ // 우선순위 선택 개수 제어
      if(this.answer.length > this.selectCnt){
        event.target.checked = false
        this.answer.pop()
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.order-list{
  position: relative;
  display: block;
  input{
    position: absolute;
    top: -1000px;
    left: -1000px;
    width:1px;
    height:1px;
    opacity: 0;
  }
  input + div{
    display: flex;
    padding: 20px;
    height: 70px;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #D9D9D9;
    border-radius: 10px;
    .order{
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background: #EBEBEB;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
    }
  }
  input:checked + div{
    border: 1px solid $color-main;
    .order{
      background: $color-main;
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>
